import { Range } from '@tiptap/core';

// Internal state stored in plugin instance
export interface SuggestionState {
	active: boolean;
	composing: boolean;
	decorationId?: string | null;
	query: null | string;
	range: Range;
	text: null | string;
}

export const createInitialState = (): SuggestionState => {
	return {
		active: false,
		range: {
			from: 0,
			to: 0,
		},
		query: null,
		text: null,
		composing: false,
	};
};
